import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useAccess = () => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.GET_STAKEHOLDERS);

  const { mutate: toggleAccess, isPending } = useAppMutation([QueryKey.TOGGLE_STAKEHOLDER_ACCESS], {
    mutationFn: (stakeholderId: string) =>
      ApiService.patch({
        endpoint: BackendRoute.STAKEHOLDERS,
        routePath: [stakeholderId, 'access'],
      }),
    onSuccess: () => {
      invalidateQuery();
    },
  });
  return { toggleAccess, isPending };
};
